import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import '@/assets'
import './vant'
import Bus from '@/utils/Bus'
import * as Tool from '@/utils/Tool'
import Config from '@/utils/Config'
import Interactive from '@/utils/Interactive'
import Request from '@/utils/Request'
import { api, nav } from '@/pages'
import CodeValue from '@/utils/CodeValue'
import Storage from '@/utils/Storage'
import '@/plugins/vant'
import { Image } from '@/utils/Image'
import Custom from '@/components'

Vue.use(Custom)
// 引入图片注册
Vue.prototype.$Image = Image
// window.SetImage = SetImage
// 引入全局广播器
Vue.use(Bus)
// 引入工具函数
Vue.prototype.$Tool = Tool
// 引入全局配置
Vue.prototype.$Config = Config
// 引入交互方法
Vue.use(Interactive)
// 引入code-value
Vue.use(CodeValue)
// 引入缓存
Vue.use(Storage)
// 引入请求方法
Vue.use(Request, {
  apiFormat: Config.apiFormat,
  hostUrl: Config.hostUrl,
  controlName: Config.controlName,
  apiObj: api,
  header: Config.header,
  successCode: Config.successCode,
  ignoreToastCode: Config.ignoreToastCode,
  showLoadingHandle: () => {
    Interactive.ShowLoading()
  },
  closeLoadingHandle: () => {
    Interactive.CloseLoading()
  },
  catchRequestHandle: (erro, resolve, reject) => {
    // Interactive.ShowToast('服务器繁忙', { icon: 'fail' })
  },
  parseData: res => {
    return res
  },
  toastHandle: res => {
    Interactive.ShowToast(res.msg)
  },
  codeHandle: {
    200: (res, again) => {},
    401: (res, again) => {
      const url = window.location.href
      sessionStorage.setItem('jql_location', JSON.stringify(url))
      nav('Common.Login')
    },
    403: (res, again) => {
      Interactive.ShowConfirm(res.msg, { showCancel: false })
    },
    404: (res, again) => {
      Interactive.ShowConfirm(res.msg, { showCancel: false }).then(() => {
        nav('back')
      })
    }
  }
})
Vue.prototype.$nav = nav

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
